<div *ngIf="contentKey" class="alert alert-warning-blue">
  <strong>Resubmittal</strong> This is a resubmittal of original content. <a [routerLink]="['/content', 'examine', type, accountKey, contentKey]" class="ml-4" target="_blank">View Original</a>
</div>
